module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "wrapper"
  }, [_c('section', {
    staticClass: "social-signup"
  }, [_c('div', {
    staticClass: "social-links"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/OpenTrons-Labworks/",
      "target": "_blank",
      "data-gtm-action": "click",
      "data-gtm-category": "Social",
      "data-gtm-label": "Open Facebook"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/opentrons-images/website/logo_facebook.png",
      "alt": "facebook logo"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/OpenTrons_",
      "target": "_blank",
      "data-gtm-action": "click",
      "data-gtm-category": "Social",
      "data-gtm-label": "Open Twitter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/opentrons-images/website/logo_twitter.png",
      "alt": "twitter logo"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/opentronslab/",
      "target": "_blank",
      "data-gtm-action": "click",
      "data-gtm-category": "Social",
      "data-gtm-label": "Open Instagram"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/opentrons-images/website/logo_instagram.png",
      "alt": "instagram logo"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCvMRmXIxnHs3AutkVhuqaQg",
      "target": "_blank",
      "data-gtm-action": "click",
      "data-gtm-category": "Social",
      "data-gtm-label": "Open Youtube"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://s3.amazonaws.com/opentrons-images/website/logo_youtube.png",
      "alt": "youtube logo"
    }
  })])]), _vm._v(" "), _c('h3', [_vm._v("Sign Up For Our Newsletter")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mc_embed_signup"
    }
  }, [_c('form', {
    staticClass: "validate",
    attrs: {
      "action": "//opentrons.us8.list-manage.com/subscribe/post?u=000595683fb96c5fb3c54cf53&id=ba66060a9c",
      "method": "post",
      "id": "mc-embedded-subscribe-form",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank",
      "novalidate": ""
    }
  }, [_c('div', {
    attrs: {
      "id": "mc_embed_signup_scroll"
    }
  }, [_c('input', {
    staticClass: "email-newsletter",
    attrs: {
      "type": "email",
      "value": "",
      "name": "EMAIL",
      "id": "mce-EMAIL",
      "placeholder": "email address",
      "required": "",
      "data-gtm-action": "input",
      "data-gtm-category": "Mailchimp",
      "data-gtm-label": "Enter Email"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "-5000px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "b_000595683fb96c5fb3c54cf53_ba66060a9c",
      "tabindex": "-1",
      "value": ""
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "gray subscribe",
    attrs: {
      "type": "submit",
      "value": "Subscribe",
      "name": "subscribe",
      "id": "mc-embedded-subscribe",
      "data-gtm-action": "click",
      "data-gtm-category": "Mailchimp",
      "data-gtm-label": "Newsletter Signup"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "copyrite"
  }, [_vm._v("© OPENTRONS 2017")])]), _vm._v(" "), _c('section', {
    staticClass: "footer-menu"
  }, [_c('ul', [_c('li', [_vm._v("Products")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://opentrons.com/robots"
    }
  }, [_vm._v("OT-One")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://opentrons.com/ot-2"
    }
  }, [_vm._v("OT-2")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://opentrons.com/pipettes"
    }
  }, [_vm._v("Pipettes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://opentrons.com/modules"
    }
  }, [_vm._v("Modules")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://opentrons.com/ot-app"
    }
  }, [_vm._v("OT App")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://protocols.opentrons.com/"
    }
  }, [_vm._v("Protocol Library")])])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Company")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://opentrons.com/about"
    }
  }, [_vm._v("About")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://opentrons.com/team"
    }
  }, [_vm._v("Team")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://blog.opentrons.com/"
    }
  }, [_vm._v("Blog")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://opentrons.com/contact"
    }
  }, [_vm._v("Contact Us")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "hiring",
    attrs: {
      "href": "https://opentrons.com/jobs",
      "target": "_blank"
    }
  }, [_vm._v("WE'RE HIRING")])])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Resources")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://support.opentrons.com",
      "target": "_blank"
    }
  }, [_vm._v("Support")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://support.opentrons.com/getting-started",
      "target": "_blank"
    }
  }, [_vm._v("Getting Started")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://docs.opentrons.com/",
      "target": "_blank"
    }
  }, [_vm._v("Opentrons API")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/Opentrons/opentrons",
      "target": "_blank"
    }
  }, [_vm._v("Open Source")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "buy",
    attrs: {
      "href": "https://shop.opentrons.com/"
    }
  }, [_vm._v("Buy")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f1e31ef8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteFooter.vue
// module id = 252
// module chunks = 2